export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Nro. orden",
          sortable: false,
          value: "numOrder"
        },
        {
          text: i18n.t('headers.provider'),
          sortable: false,
          value: "provider"
        },
        {
          text: "Nombre del paciente",
          value: "patientName",
          sortable: false
        },
        {
          text: "Total cuota moderadora",
          value: "totalModeratorFee",
          sortable: false
        },
        {
          text: "Fecha de carga",
          value: "loadingDate",
          sortable: false
        },
        {
          text: "Estado",
          value: "",
          sortable: false
        }
      ],
      itemsData: [
        {
          numOrder: 1,
          provider: "Farmadomicilios",
          patientName: "Pepito",
          totalModeratorFee: 2000,
          loadingDate: "2019-08-08"
        },
        {
          numOrder: 1,
          provider: "Farmadomicilios",
          patientName: "Pepito",
          totalModeratorFee: 2000,
          loadingDate: "2019-08-08"
        }
      ]
    };
  },
  props: {},
  watch: {},
  methods: {
    onRowClick(item) {
      this.$emit("row-click", item);
    }
  }
};
